import { render, staticRenderFns } from "./ReopenDialog.vue?vue&type=template&id=4277f021"
import script from "./ReopenDialog.vue?vue&type=script&lang=js"
export * from "./ReopenDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports